import { render, staticRenderFns } from "./DadosContato.vue?vue&type=template&id=04e6581c"
import script from "./DadosContato.vue?vue&type=script&lang=js"
export * from "./DadosContato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports